import { render, staticRenderFns } from "./index.vue?vue&type=template&id=665f87a7&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665f87a7')) {
      api.createRecord('665f87a7', component.options)
    } else {
      api.reload('665f87a7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=665f87a7&lang=pug", function () {
      api.rerender('665f87a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/consultant/classRecords/viewAnalysis/index.vue"
export default component.exports